import { render } from "./switchOperationsMenuSelect.vue?vue&type=template&id=6f356fb9&scoped=true"
import script from "./switchOperationsMenuSelect.vue?vue&type=script&lang=js"
export * from "./switchOperationsMenuSelect.vue?vue&type=script&lang=js"

import "./switchOperationsMenuSelect.vue?vue&type=style&index=0&id=6f356fb9&lang=css&scoped=true"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f356fb9"]])

export default __exports__